export const films = [
  {
    id: "haru-no-kizu",
    title: "春之阙",
    titleEn: "Haru no Kizu",
    year: 2021,
    region: "日本",
    category: "电影",
    genres: ["伦理剧情", "爱情伦理"],
    director: "佐藤真澄",
    cast: ["高桥宁宁", "村上慧", "小林千夏"],
    duration: "118分钟",
    score: 8.4,
    popularity: 96,
    poster: "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20art%20of%20a%20young%20woman%20in%20a%20pale%20linen%20dress%20standing%20by%20a%20rain%20streaked%20window%20at%20dusk%2C%20soft%20spring%20light%2C%20muted%20teal%20and%20warm%20ivory%20tones%2C%2035mm%20film%20grain%2C%20quiet%20melancholy%2C%20no%20text&width=600&height=900&seq=film-poster-01&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20frame%20of%20a%20woman%20standing%20alone%20by%20a%20huge%20rain%20streaked%20window%20in%20a%20quiet%20Japanese%20apartment%2C%20soft%20overcast%20spring%20light%2C%20muted%20teal%20and%20warm%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20analog%20film%20grain%2C%20editorial%20cinematography%2C%20no%20text&width=1600&height=900&seq=film-hero-01&orientation=landscape",
    tagline: "有些婚姻不是破裂，只是被一点点省略。",
    summary:
      "一场持续十二年的婚姻在樱花季出现裂缝。出版社编辑美纱在整理丈夫遗落的旧信件时，发现了一个陌生女人的名字，也发现自己在所有信件里都不曾被写下一句。她开始用编辑职业的习惯，逐字核对共同生活的每一页。",
    analysis: [
      "影片把「背叛」处理成一种缓慢的日常：不是戏剧性的捉奸，而是便当盒里少放的一颗梅子、玄关处多出的一双拖鞋。导演佐藤真澄用大量固定机位的中景，让观众与美纱保持同样的距离——看得见，却始终触不到。",
      "樱花在片中反复出现，却并不是浪漫符号，而是时间的刻度。花开时美纱还在追问，花落时她已经不再需要答案。用季节推进心理转折，让结尾的沉默比任何争吵都更有力量。",
      "高桥宁宁的表演克制到近乎冷静，她把愤怒都收在手指的细微动作里。影片真正讨论的不是出轨本身，而是「被省略」这件事如何一点点掏空一个人。",
    ],
    tags: ["婚外关系", "女性视角", "季节意象", "文学改编"],
    featured: true,
    editorPick: true,
    addedAt: "2025-04-18",
  },
  {
    id: "before-the-rain-stops",
    title: "雨停之前",
    titleEn: "Before the Rain Stops",
    year: 2023,
    region: "韩国",
    category: "电影",
    genres: ["悬疑伦理", "犯罪伦理"],
    director: "尹度贤",
    cast: ["韩素理", "朴正宇", "金多恩"],
    duration: "124分钟",
    score: 8.7,
    popularity: 98,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20an%20empty%20rain%20soaked%20Seoul%20alley%20at%20night%2C%20reflections%20on%20wet%20asphalt%2C%20a%20distant%20woman%20with%20an%20umbrella%20in%20silhouette%2C%20muted%20navy%20and%20amber%20streetlight%20tones%2C%20analog%20film%20grain%2C%20no%20text&width=600&height=900&seq=film-poster-02&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Rain%20drenched%20narrow%20Korean%20street%20at%20night%2C%20neon%20reflections%20on%20black%20asphalt%2C%20lone%20figure%20with%20umbrella%20walking%20away%2C%20deep%20navy%20shadows%20with%20warm%20amber%20streetlights%2C%20cinematic%20anamorphic%20framing%2C%20moody%20thriller%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-hero-02&orientation=landscape",
    tagline: "她只想让雨停，却先把整座城市的谎言淋湿了。",
    summary:
      "一名负责性犯罪案件的女性检察官，在连续暴雨的七天里接手一桩证据链几乎完美的案件。证人、监控、笔录彼此咬合得天衣无缝，唯有天气报告显示，那晚根本没有下雨。她决定从一句谎言开始，拆掉整座城市的体面。",
    analysis: [
      "双线叙事是这部片最锋利的地方：一条是检察官追查物证的现在线，一条是十年前受害者视角的回忆线。两条线在同一个雨夜交叉，观众比角色更早意识到真相，于是悬念从「谁做的」转向「为什么所有人都选择不说」。",
      "影片对程序正义的讨论并不说教。它把镜头交给走廊、档案室、复印机的白光，让体制的冷漠变成一种视觉经验。真正的压迫感来自那些礼貌而无效的对话。",
      "韩素理的表演有两副面孔：法庭上的精确，和独处时突然的失神。结尾她没有赢，只是让雨停了三十秒——这三十秒，是导演留给观众呼吸的地方。",
    ],
    tags: ["雨夜", "真相", "双线叙事", "法律边界"],
    featured: true,
    editorPick: true,
    addedAt: "2025-06-02",
  },
  {
    id: "neighbor-in-daylight",
    title: "白昼之邻",
    titleEn: "Neighbor in Daylight",
    year: 2019,
    region: "韩国",
    category: "电视剧",
    genres: ["家庭伦理", "悬疑伦理"],
    director: "郑河那",
    cast: ["李瑞妍", "姜允在", "崔武成"],
    duration: "12集 · 单集62分钟",
    score: 8.1,
    popularity: 92,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20quiet%20suburban%20apartment%20corridor%20in%20daylight%2C%20a%20half%20open%20door%20with%20soft%20light%20spilling%20out%2C%20two%20indistinct%20figures%20reflected%20in%20glass%2C%20desaturated%20slate%20and%20cream%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-03&orientation=portrait",
    tagline: "最好的邻居，往往藏着最完整的一家人。",
    summary:
      "一栋住着十二户人家的老式公寓，白天安静得像标本盒。新搬来的单身母亲发现，对门那户永远在下午三点准时拉开窗帘，却从没有人真正走出来过。她开始记录这栋楼里所有不合常理的日常。",
    analysis: [
      "这是一部把「邻里」拍成心理地形的剧集。走廊、楼梯转角、垃圾投放点，都成为信息交换的场所。导演刻意不给任何一户完整的家庭全景，观众只能从碎片里拼出关系。",
      "全剧最精彩的不是谜底，而是每集片尾那三分钟：镜头静止在同一个楼道口，不同住户进出，观众逐渐学会从鞋子的数量判断屋里的秘密。",
      "它讨论的伦理问题很具体——当你知道邻居家可能有问题，介入的边界在哪里？剧集没有给答案，只给了十二种不同的沉默方式。",
    ],
    tags: ["邻里关系", "家庭秘密", "群像", "日常悬疑"],
    featured: false,
    editorPick: true,
    addedAt: "2025-01-22",
  },
  {
    id: "between-tides",
    title: "潮汐之间",
    titleEn: "Between Tides",
    year: 2022,
    region: "日本",
    category: "电影",
    genres: ["伦理剧情", "家庭伦理"],
    director: "三浦京子",
    cast: ["松冈莉子", "大西隼人", "田中悠"],
    duration: "106分钟",
    score: 8.3,
    popularity: 90,
    poster: "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20of%20a%20rocky%20Japanese%20coastline%20at%20low%20tide%2C%20two%20distant%20figures%20walking%20apart%2C%20overcast%20silver%20light%2C%20muted%20sea%20green%20and%20sand%20tones%2C%20grainy%20analog%20texture%2C%20no%20text&width=600&height=900&seq=film-poster-04&orientation=portrait",
    tagline: "退潮之后，才能看见谁一直站在原地。",
    summary:
      "母亲去世后，姐妹俩回到濑户内海的小岛处理一间老屋。房产证上写着一个她们都不认识的名字，而岛上所有人都说，那个人每年夏天都来过，只是从不进这栋房子。",
    analysis: [
      "三浦京子把悬疑藏进了风景里。潮水的涨落构成全片的时间表，很多关键信息不是台词说出来的，而是镜头在低潮时露出的一块礁石、一口沉箱。",
      "两姐妹的关系是全片的伦理核心：一个想尽快卖掉，一个想留住所有东西。她们的争吵总是发生在做家务的间隙，最后谁也没赢，房子还是空了。",
      "影片对「遗产」的理解并不止于房产。真正被继承下来的，是母亲一生没有说出口的那个决定。结尾姐妹并肩坐在堤坝上，没有和解，只有共同的沉默。",
    ],
    tags: ["海岛", "母女", "遗产", "慢节奏"],
    featured: true,
    editorPick: true,
    addedAt: "2025-03-05",
  },
  {
    id: "silent-testimony",
    title: "无声的证词",
    titleEn: "Silent Testimony",
    year: 2020,
    region: "韩国",
    category: "电视剧",
    genres: ["悬疑伦理", "犯罪伦理"],
    director: "徐真浩",
    cast: ["文彩英", "赵显宇", "白承勋"],
    duration: "10集 · 单集58分钟",
    score: 8.5,
    popularity: 94,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20an%20empty%20courtroom%20corridor%20with%20tall%20windows%2C%20long%20shadows%20on%20a%20polished%20floor%2C%20a%20woman%20in%20a%20dark%20coat%20seen%20from%20behind%2C%20cold%20muted%20blue%20and%20ash%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-05&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Empty%20courtroom%20corridor%20with%20tall%20arched%20windows%2C%20long%20shadows%20across%20a%20polished%20stone%20floor%2C%20one%20woman%20in%20a%20dark%20coat%20standing%20far%20away%2C%20cold%20muted%20blue%20palette%2C%20high%20contrast%20cinematic%20lighting%2C%20quiet%20institutional%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-hero-03&orientation=landscape",
    tagline: "所有人都在说话，只有她在数沉默的长度。",
    summary:
      "一名手语翻译被临时指派为一桩家庭案件的庭审翻译。她很快发现，被告的陈述与翻译内容之间存在微妙的偏差——不是错误，而是有人刻意让她翻错。她必须在职业伦理与真相之间选择。",
    analysis: [
      "剧集把「翻译」变成一种权力。语言在这里不是中性的通道，而是可以被修饰、删减、重新排序的过滤器。每一次手语特写都在提醒观众：你看到的也不是真相。",
      "十集结构非常工整，每集以一段不同的证词开场，再回到翻译员的视角。观众的信息量与主角同步增长，这种平等感让最后的反转格外难受。",
      "它真正追问的是职业伦理的边界：当你被要求成为系统的一部分，你还能保留多少自己的判断？剧集没有把主角写成英雄，她只是选择了一次不翻译。",
    ],
    tags: ["法庭", "受害者", "媒体伦理", "职业困境"],
    featured: true,
    editorPick: false,
    addedAt: "2024-11-14",
  },
  {
    id: "echoes-of-summer",
    title: "夏日回声",
    titleEn: "Echoes of Summer",
    year: 2018,
    region: "日本",
    category: "电影",
    genres: ["爱情伦理", "伦理剧情"],
    director: "小林纪夫",
    cast: ["桥本爱子", "中村海斗", "藤井千寻"],
    duration: "98分钟",
    score: 7.9,
    popularity: 82,
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20poster%20of%20a%20sunlit%20Japanese%20summer%20field%20with%20tall%20grass%2C%20white%20curtains%20blowing%20in%20an%20open%20window%2C%20faded%20warm%20gold%20and%20green%20tones%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=900&seq=film-poster-06&orientation=portrait",
    tagline: "那年夏天说的每句话，都在十年后回了音。",
    summary:
      "三十五岁的录音师回到故乡为一个即将拆除的老电影院做声音存档。在空荡荡的放映厅里，她听见了十年前自己录下的一段对话——那段对话，改变了三个人的人生。",
    analysis: [
      "声音是这部电影真正的主角。导演用大量环境音替代配乐，蝉鸣、风扇、胶片走带声层层叠加，让回忆有了可触摸的质地。",
      "影片不回避伦理上的含糊：当年的选择没有绝对的对错，只有谁先松手。十年后回望，所有人都成了那个夏天的共犯。",
      "结尾没有重逢。她只是把那段录音留在了即将被推倒的建筑里，让声音和房子一起消失。这是导演最温柔也最残酷的处理。",
    ],
    tags: ["初恋", "回忆", "乡村", "声音设计"],
    featured: false,
    editorPick: false,
    addedAt: "2024-08-09",
  },
  {
    id: "paper-moon",
    title: "纸月亮",
    titleEn: "Paper Moon",
    year: 2024,
    region: "韩国",
    category: "电影",
    genres: ["伦理剧情", "悬疑伦理"],
    director: "车敏书",
    cast: ["申河琳", "柳在勋", "金多恩"],
    duration: "112分钟",
    score: 8.6,
    popularity: 97,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20woman%20holding%20a%20paper%20moon%20lantern%20in%20a%20dim%20room%2C%20deep%20shadows%20and%20a%20single%20warm%20light%20source%2C%20muted%20charcoal%20and%20cream%20tones%2C%20elegant%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-07&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Dim%20backstage%20theatre%20with%20a%20huge%20paper%20moon%20prop%20hanging%20above%20an%20empty%20stage%2C%20a%20lone%20woman%20in%20a%20dark%20dress%20standing%20in%20the%20wings%2C%20warm%20single%20spotlight%2C%20muted%20charcoal%20and%20cream%20palette%2C%20cinematic%20mystery%20mood%2C%20no%20text&width=1600&height=900&seq=film-hero-04&orientation=landscape",
    tagline: "替别人活久了，会忘记自己的名字怎么写。",
    summary:
      "一位常年做替身的舞台剧女演员，在主演突然失踪后被推上灯光之下。她演得越好，越没有人愿意相信她原本是谁。当警方开始调查失踪案，她发现自己成了最方便的那个嫌疑人。",
    analysis: [
      "影片的结构像一出三幕剧，每一幕都在拆解「表演」这件事：台上的表演、生活里的表演、审讯室里的表演。到第三幕，观众已经分不清哪一层才是她。",
      "车敏书用强烈的明暗对比制造舞台感，很多镜头只在人物半张脸上打光。这种视觉上的不完整，正好对应她始终无法被完整叙述的身份。",
      "申河琳的表演值得单独拿出来说。她在同一场戏里完成了三个层次的情绪转换，却没有任何一个瞬间是夸张的。结尾她站在空舞台中央报出自己的本名，是全片最安静的爆发。",
    ],
    tags: ["剧场", "替身", "身份", "女性主角"],
    featured: true,
    editorPick: true,
    addedAt: "2025-09-12",
  },
  {
    id: "sea-in-the-room",
    title: "房间里的海",
    titleEn: "The Sea in the Room",
    year: 2017,
    region: "日本",
    category: "短片",
    genres: ["伦理剧情", "爱情伦理"],
    director: "石川怜",
    cast: ["森川葵", "冈田亮"],
    duration: "32分钟",
    score: 8.0,
    popularity: 76,
    poster: "https://readdy.ai/api/search-image?query=Artistic%20short%20film%20poster%20of%20a%20small%20room%20with%20the%20sea%20projected%20on%20the%20wall%2C%20a%20chair%20and%20a%20vase%20in%20silhouette%2C%20muted%20teal%20and%20dusty%20pink%20tones%2C%20dreamlike%20grain%2C%20no%20text&width=600&height=900&seq=film-poster-08&orientation=portrait",
    tagline: "他们用一台投影仪，把海搬进了三十平米的房间。",
    summary:
      "一对分居中的夫妻在搬空公寓的最后一天，决定用投影仪把两人唯一一次旅行的影像放满整面墙。三十二分钟里，他们几乎不谈感情，只是讨论窗帘要不要留下。",
    analysis: [
      "这是一部关于「最后一晚」的短片，空间极小，信息量却惊人。导演把家具的每一处空缺都拍成了情绪，搬走的书架留下的墙色，比任何台词都更响。",
      "投影的海是全片唯一的「外景」，也是唯一没有争吵的地方。当影像终于铺满墙壁，两人反而安静了——他们终于有了共同面对的东西。",
      "结尾没有挽留。门关上，投影还亮着，海留在空房间里。短片的力量在于它只给你三十二分钟，却让你想了很久。",
    ],
    tags: ["密室", "影像实验", "孤独", "分居"],
    featured: false,
    editorPick: false,
    addedAt: "2024-05-21",
  },
  {
    id: "midnight-clinic",
    title: "深夜诊疗所",
    titleEn: "Midnight Clinic",
    year: 2021,
    region: "韩国",
    category: "电视剧",
    genres: ["伦理剧情", "家庭伦理"],
    director: "罗英植",
    cast: ["金惠媛", "李政烨", "朴昭熙"],
    duration: "8集 · 单集45分钟",
    score: 8.2,
    popularity: 88,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20late%20night%20clinic%20reception%20desk%20with%20a%20single%20lamp%2C%20empty%20waiting%20chairs%2C%20rain%20outside%20the%20glass%20door%2C%20muted%20green%20and%20amber%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-09&orientation=portrait",
    tagline: "白天的病有名字，夜里的病只有人。",
    summary:
      "首尔一间只在午夜到凌晨四点营业的小诊所，接待的都是不能在白天出现的人。八集，八个夜晚，八个不愿留下姓名的病人，以及一位始终不肯解释自己为什么留在这里的医生。",
    analysis: [
      "每集独立成篇，又通过诊所的空间串联起来。导演几乎不用闪回，所有背景信息都靠对话里不经意的停顿透露，克制得恰到好处。",
      "剧集最动人的地方是它对「不方便」的尊重。病人的选择未必正确，但剧集从不急着审判，只是让他们在灯下坐满十五分钟。",
      "第八集揭开医生留下的原因时，前七集的细节全部重新排列。原来这部剧一早在讲同一件事：每个人都欠着另一个人一个夜晚。",
    ],
    tags: ["夜班", "医患", "城市孤独", "单元剧"],
    featured: false,
    editorPick: true,
    addedAt: "2024-12-03",
  },
  {
    id: "snow-falls-quietly",
    title: "雪落无声",
    titleEn: "Snow Falls Quietly",
    year: 2016,
    region: "日本",
    category: "电影",
    genres: ["家庭伦理", "伦理剧情"],
    director: "佐藤真澄",
    cast: ["吉冈理惠", "高木修", "小林千夏"],
    duration: "121分钟",
    score: 8.8,
    popularity: 91,
    poster: "https://readdy.ai/api/search-image?query=Minimal%20cinematic%20poster%20of%20a%20snowy%20Japanese%20village%20street%20at%20blue%20hour%2C%20one%20figure%20in%20a%20long%20coat%20walking%20away%2C%20pale%20grey%20blue%20palette%20with%20warm%20window%20lights%2C%20no%20text&width=600&height=900&seq=film-poster-10&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Snow%20covered%20Japanese%20village%20street%20at%20blue%20hour%2C%20warm%20glowing%20windows%2C%20a%20single%20figure%20in%20a%20long%20dark%20coat%20walking%20away%20through%20falling%20snow%2C%20pale%20grey%20blue%20palette%2C%20wide%20cinematic%20composition%2C%20quiet%20melancholy%2C%20no%20text&width=1600&height=900&seq=film-hero-05&orientation=landscape",
    tagline: "父亲一生只说过三次真话，每一次都在下雪。",
    summary:
      "在北方小镇经营木工房的父亲突然中风，失去语言能力。住在东京的女儿赶回来，发现父亲的账本上有一笔持续二十年的汇款，收款人是一个她从未听说过的人。",
    analysis: [
      "影片最特别的处理，是让父亲全程几乎不说话。所有的表达都通过手势、眼神和木工房里的物件完成。沉默不是留白，而是另一种密集的语言。",
      "女儿的调查线并不追求揭晓。她找到了收款人，却没有质问，只是坐下来喝了一杯茶。这场戏几乎没有台词，却是全片伦理张力的最高点。",
      "佐藤真澄把「原谅」拍成了一件很不戏剧化的事：它发生在扫雪、煮饭、修一扇关不严的窗之间。雪停的时候，父女俩都没有说破，但屋子已经不那么冷了。",
    ],
    tags: ["北方小镇", "父女", "沉默", "木工"],
    featured: true,
    editorPick: true,
    addedAt: "2024-10-08",
  },
  {
    id: "her-second-name",
    title: "她的第二个名字",
    titleEn: "Her Second Name",
    year: 2022,
    region: "韩国",
    category: "电影",
    genres: ["悬疑伦理", "伦理剧情"],
    director: "尹度贤",
    cast: ["韩素理", "具承模", "白承勋"],
    duration: "116分钟",
    score: 8.4,
    popularity: 93,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20woman%20seen%20twice%20through%20a%20mirror%20reflection%2C%20split%20lit%20portrait%20in%20a%20hotel%20room%2C%20muted%20burgundy%20and%20slate%20tones%2C%20elegant%20tension%2C%20no%20text&width=600&height=900&seq=film-poster-11&orientation=portrait",
    tagline: "她用两个名字活着，直到两个名字开始互相写信。",
    summary:
      "一间老酒店的前台经理，同时以两个身份生活了十五年。一个名字属于家庭，一个名字属于自己。当一位长期住客认出她年轻时的照片，两个身份第一次出现在同一个房间里。",
    analysis: [
      "影片对「身份」的讨论很聪明地避开了失忆或伪装的老套，它说的是主动选择的分裂：为了活下去，她给自己造了一个更安全的人。",
      "镜子是全片最重要的道具。前半段镜中是两个不同的人，后半段镜框开始出现裂缝，直到最后一面镜子被搬走，她只剩一个可见的倒影。",
      "结尾没有揭露，也没有惩罚。她递交了辞职信，坐在酒店大堂等天亮。这个开放处理让影片从悬疑片变成了一部关于自我接纳的作品。",
    ],
    tags: ["身份置换", "酒店", "记忆", "女性"],
    featured: false,
    editorPick: true,
    addedAt: "2025-02-16",
  },
  {
    id: "glass-greenhouse",
    title: "玻璃温室",
    titleEn: "Glass Greenhouse",
    year: 2019,
    region: "日本",
    category: "电视剧",
    genres: ["家庭伦理", "爱情伦理"],
    director: "三浦京子",
    cast: ["松冈莉子", "西岛俊", "藤井千寻"],
    duration: "11集 · 单集50分钟",
    score: 7.8,
    popularity: 79,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20glass%20greenhouse%20at%20dusk%2C%20condensation%20on%20the%20panes%2C%20a%20woman%20watering%20plants%20in%20silhouette%2C%20muted%20olive%20and%20warm%20grey%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-12&orientation=portrait",
    tagline: "这个家最透明的地方，藏着最不肯说的事。",
    summary:
      "经营三代的花卉农场面临被收购，长女从东京回到乡下接手。玻璃温室是她童年最喜欢的地方，也是全家唯一没有秘密的地方——直到她在土里挖出一只不属于这个年代的铁盒。",
    analysis: [
      "十一集的体量给了人物充分的空间。每个人都在为「留下来」或「卖掉」找理由，理由后面是各自不愿承认的私心。",
      "温室的玻璃成为一种隐喻：越透明，越容易被忽略擦不干净的那一面。剧中反复出现的擦拭动作，是全剧最温柔的伏笔。",
      "它没有把家族企业写成悲情叙事，而是诚实地拍出了经营的压力、代际的误解，以及一句迟到了三十年的道歉。",
    ],
    tags: ["家族企业", "继承", "植物意象", "乡村"],
    featured: false,
    editorPick: false,
    addedAt: "2024-07-11",
  },
  {
    id: "last-subway",
    title: "末班地铁",
    titleEn: "Last Subway",
    year: 2020,
    region: "韩国",
    category: "短片",
    genres: ["悬疑伦理", "伦理剧情"],
    director: "徐真浩",
    cast: ["文彩英", "吴承泽"],
    duration: "27分钟",
    score: 7.7,
    popularity: 71,
    poster: "https://readdy.ai/api/search-image?query=Moody%20short%20film%20poster%20of%20an%20empty%20last%20train%20carriage%20at%20night%2C%20fluorescent%20light%20and%20dark%20windows%2C%20a%20lone%20passenger%20at%20the%20far%20end%2C%20muted%20blue%20green%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-13&orientation=portrait",
    tagline: "凌晨一点十七分，车厢里多了一个不该在的人。",
    summary:
      "末班地铁上只剩两名乘客。一个刚下夜班的护士，一个抱着纸箱的男人。列车在隧道里停下七分钟，灯灭了三次。第七分钟，男人开口说了一句她十五年前听过的话。",
    analysis: [
      "二十七分钟的短片，几乎全部发生在同一个车厢。导演用灯光的变化划分段落，每灭一次灯，人物关系就重新洗牌一次。",
      "它的伦理题眼是「认错人」：我们记住的到底是一个人，还是那个人在某个瞬间给过我们的感觉？短片没有给标准答案。",
      "结尾列车到站，两人各自离开。站台的监控画面里，车厢是空的。这个镜头让整部短片从写实悄悄滑进了另一种可能。",
    ],
    tags: ["都市", "午夜", "陌生人", "单场景"],
    featured: false,
    editorPick: false,
    addedAt: "2024-04-02",
  },
  {
    id: "afterglow",
    title: "余温",
    titleEn: "Afterglow",
    year: 2023,
    region: "日本",
    category: "电影",
    genres: ["爱情伦理", "伦理剧情"],
    director: "小林纪夫",
    cast: ["桥本爱子", "大西隼人", "田中悠"],
    duration: "102分钟",
    score: 8.5,
    popularity: 95,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20an%20unmade%20bed%20by%20a%20large%20window%20in%20late%20afternoon%2C%20dust%20in%20the%20light%2C%20a%20woman%20tying%20her%20hair%20in%20the%20doorway%2C%20muted%20terracotta%20and%20cream%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-14&orientation=portrait",
    tagline: "关系结束的那天，房间还是温的。",
    summary:
      "一对在一起七年的恋人决定用一天时间，把共同生活过的公寓彻底分开。从早上分书，到傍晚分一只猫，他们尽量保持礼貌，直到发现冰箱上还留着去年的便条。",
    analysis: [
      "全片几乎只有一个场景，却丝毫不闷。导演把时间切成一段段家务：整理、打包、擦地、做饭。感情在这些动作里缓慢显影，比任何争吵都更真实。",
      "午后那场戏最有力量：两人坐在空了一半的客厅里吃外卖，聊的却是无关紧要的天气。那种「已经没有资格关心对方」的克制，是整部电影的核心。",
      "结尾没有复合，也没有撕破脸。她抱着猫下楼，他留在门口。镜头停在门把手上，余温这个词第一次有了具体的重量。",
    ],
    tags: ["午后", "离开", "日常", "长镜头"],
    featured: false,
    editorPick: true,
    addedAt: "2025-05-27",
  },
  {
    id: "red-thread",
    title: "红绳",
    titleEn: "Red Thread",
    year: 2015,
    region: "韩国",
    category: "电影",
    genres: ["爱情伦理", "悬疑伦理"],
    director: "郑河那",
    cast: ["李瑞妍", "姜允在", "崔武成"],
    duration: "108分钟",
    score: 8.0,
    popularity: 84,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20red%20thread%20tied%20around%20a%20wrist%20against%20dark%20fabric%2C%20close%20up%20of%20hands%2C%20deep%20shadows%20and%20warm%20cream%20light%2C%20minimal%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-15&orientation=portrait",
    tagline: "有些缘分不是命，是有人一直没放手。",
    summary:
      "一位民俗学者在整理地方传说时，发现同一个故事在三个村庄被讲了三个版本。故事里的女人都系着红绳，都在婚礼前夜消失。她的调查把她带回了自己母亲的故乡。",
    analysis: [
      "影片把民俗研究拍成了侦探工作：比对版本、查证口述、翻旧报纸。这种近乎学术的节奏反而制造出强烈的悬念。",
      "红绳的意象在片中不断变形——护身符、礼物、证物、遗物。到最后它不再象征姻缘，而是一个人被反复叙述、反复定义的命运。",
      "李瑞妍把学者的冷静和女儿的脆弱放在同一张脸上。她最后烧掉的那根绳子，既是切断，也是替母亲做的一次选择。",
    ],
    tags: ["宿命", "旧爱", "民俗", "地方传说"],
    featured: false,
    editorPick: false,
    addedAt: "2024-03-19",
  },
  {
    id: "old-inn-by-the-sea",
    title: "海边的旧旅馆",
    titleEn: "The Old Inn by the Sea",
    year: 2018,
    region: "日本",
    category: "电视剧",
    genres: ["家庭伦理", "伦理剧情"],
    director: "石川怜",
    cast: ["田中悠", "森川葵", "吉冈理惠"],
    duration: "9集 · 单集48分钟",
    score: 8.1,
    popularity: 86,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20an%20old%20seaside%20inn%20with%20wooden%20corridors%2C%20open%20shoji%20screens%20facing%20the%20ocean%2C%20muted%20indigo%20and%20sand%20tones%2C%20quiet%20nostalgic%20atmosphere%2C%20no%20text&width=600&height=900&seq=film-poster-16&orientation=portrait",
    tagline: "旅馆记了四十年的客人名册，少了一页。",
    summary:
      "一家开了四十年的海边旅馆即将歇业。老板娘的儿子回来帮忙处理最后的住客，却在旧名册里发现整页被撕掉的记录，以及一个每年同一天都会出现的房号。",
    analysis: [
      "九集像一个慢慢退潮的过程。每一集招待一位老客人，也带走一段往事，旅馆的房间一间间空下来。",
      "导演把海拍得很有距离感：它一直在窗外，从不参与剧情，却决定了所有人的生活节奏。旅馆里的人都在等一件事，海从不等。",
      "最后一集没有揭开撕掉的那页写了什么，只让儿子把名册放回抽屉。有些家史不需要真相，只需要有人记得曾经发生过。",
    ],
    tags: ["旅馆", "家族史", "海边", "慢叙事"],
    featured: false,
    editorPick: false,
    addedAt: "2024-09-30",
  },
  {
    id: "the-third-chair",
    title: "第三张椅子",
    titleEn: "The Third Chair",
    year: 2024,
    region: "日本",
    category: "短片",
    genres: ["伦理剧情", "悬疑伦理"],
    director: "佐藤真澄",
    cast: ["高桥宁宁", "中村海斗"],
    duration: "24分钟",
    score: 8.3,
    popularity: 80,
    poster: "https://readdy.ai/api/search-image?query=Artistic%20short%20film%20poster%20of%20three%20empty%20chairs%20in%20a%20bare%20room%2C%20hard%20window%20light%20casting%20long%20shadows%2C%20muted%20grey%20and%20amber%20tones%2C%20minimal%20still%20life%2C%20no%20text&width=600&height=900&seq=film-poster-17&orientation=portrait",
    tagline: "房间里只有两个人，但每次谈话都有三种版本。",
    summary:
      "一间只有两把椅子的排练室里，多出了第三把。男人说是他带来的，女人说她从没见过。二十四分钟里，同一段对话被重复了四次，每次都少一点，也每次都不一样。",
    analysis: [
      "这是一部很「舞台」的短片：固定机位、极少调度、全靠台词和停顿推进。第三把椅子从头到尾没坐过人，却是全片最重的角色。",
      "四次重复不是炫技，而是逐渐剥落的过程。第一遍是争吵，第三遍是回忆，第四遍只剩呼吸声。导演在测试观众愿意相信哪一版。",
      "短片最后没有解释椅子从哪来。它只把镜头停在那块空位上，让观众自己坐进去。",
    ],
    tags: ["三人关系", "舞台感", "留白", "重复结构"],
    featured: false,
    editorPick: true,
    addedAt: "2025-08-21",
  },
  {
    id: "her-in-the-fog",
    title: "迷雾中的她",
    titleEn: "Her in the Fog",
    year: 2021,
    region: "韩国",
    category: "电影",
    genres: ["悬疑伦理", "伦理剧情"],
    director: "车敏书",
    cast: ["申河琳", "朴正宇", "金多恩"],
    duration: "114分钟",
    score: 8.2,
    popularity: 89,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20in%20a%20beige%20coat%20disappearing%20into%20thick%20fog%20on%20a%20bridge%2C%20soft%20diffused%20light%2C%20muted%20grey%20and%20rust%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=film-poster-18&orientation=portrait",
    tagline: "所有人都见过她，没有人能说清她长什么样。",
    summary:
      "一名保险公司调查员被派去核实一起失踪案。失踪的女人的丈夫、同事、楼下便利店的店员，每个人都提供了详细的描述，但四份描述指向四个不同的人。雾散的那天，调查员开始怀疑自己的记忆。",
    analysis: [
      "不可靠叙述在这部片里被推到极致：不是某一个人在说谎，而是所有人的记忆都在合力制造一个不存在的人。",
      "雾是视觉主题，也是叙事方法。前半段镜头始终保持一点模糊，观众被迫和调查员一样，在信息不足的情况下做判断。",
      "影片最后给了一个极其克制的答案：她存在过，只是没有活成任何人描述的样子。这句话也让整部片的伦理指向变得清晰——被观看的人，也有权不被定义。",
    ],
    tags: ["失踪", "桥", "不可靠叙述", "记忆"],
    featured: false,
    editorPick: true,
    addedAt: "2025-07-03",
  },
  {
    id: "vernal-equinox",
    title: "春分",
    titleEn: "Vernal Equinox",
    year: 2014,
    region: "日本",
    category: "电影",
    genres: ["爱情伦理", "伦理剧情"],
    director: "三浦京子",
    cast: ["小林千夏", "高木修", "藤井千寻"],
    duration: "96分钟",
    score: 7.6,
    popularity: 68,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20cherry%20blossom%20petals%20on%20a%20dark%20wooden%20floor%2C%20a%20womans%20bare%20feet%20and%20the%20hem%20of%20a%20dress%2C%20muted%20pink%20and%20ink%20tones%2C%20delicate%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-19&orientation=portrait",
    tagline: "昼夜等长的这一天，他们决定把过去平分。",
    summary:
      "一对离婚多年的男女在春分这天回到旧宅，处理最后一批共同财产。二十四小时里，他们从客套聊到争吵，从争吵聊到当年的那场误会，最后一起把院子里的樱树修剪了一遍。",
    analysis: [
      "影片的时间结构与节气严格对应：从日出到日落，恰好十二小时。导演在片头片尾各放了一次空镜，让观众意识到日子真的过去了。",
      "旧宅是第三个角色。墙上的身高刻度、厨房的旧瓷砖、院子里那棵樱树，都在替他们说话，而他们自己始终说不出口。",
      "这不是一部关于复合的电影，而是关于「结算」。当所有东西都分完，两个人反而第一次平等地看对方。",
    ],
    tags: ["四季", "旧宅", "重逢", "时间结构"],
    featured: false,
    editorPick: false,
    addedAt: "2024-02-28",
  },
  {
    id: "borrowed-diary",
    title: "借来的日记",
    titleEn: "Borrowed Diary",
    year: 2022,
    region: "韩国",
    category: "短片",
    genres: ["伦理剧情", "家庭伦理"],
    director: "罗英植",
    cast: ["朴昭熙", "金多恩"],
    duration: "29分钟",
    score: 7.9,
    popularity: 73,
    poster: "https://readdy.ai/api/search-image?query=Short%20film%20poster%20of%20an%20open%20diary%20and%20a%20fountain%20pen%20on%20a%20windowsill%2C%20handwriting%20blurred%2C%20late%20afternoon%20light%2C%20muted%20cream%20and%20sepia%20tones%2C%20no%20text&width=600&height=900&seq=film-poster-20&orientation=portrait",
    tagline: "她借走了母亲的日记，也借走了母亲没说出口的二十年。",
    summary:
      "准备出国留学的女儿在整理房间时，把母亲放在抽屉里的日记装进了行李。二十九年后的同一天，她带着那本日记回到老家，母亲已经不记得她是谁。",
    analysis: [
      "短片用交叉剪辑连接两个时空：女儿的旅行和母亲的日常。两边的时间流速不同，观众比女儿更早明白遗忘已经开始。",
      "日记里的内容始终没有完整念出来，只有零星几句被女儿读给自己听。这种节制让情感没有被消费，反而更重。",
      "结尾她把日记放回原抽屉。母亲问她是哪家的姑娘，她说自己是来借书的。二十九分钟，完成了一次漫长的归还。",
    ],
    tags: ["日记", "母女", "代际", "遗忘"],
    featured: false,
    editorPick: false,
    addedAt: "2025-04-09",
  },
  {
    id: "silent-confession",
    title: "静默的告白",
    titleEn: "Silent Confession",
    year: 2019,
    region: "日本",
    category: "电影",
    genres: ["伦理剧情", "家庭伦理"],
    director: "小林纪夫",
    cast: ["吉冈理惠", "西岛俊", "田中悠"],
    duration: "119分钟",
    score: 8.6,
    popularity: 92,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20two%20people%20sitting%20apart%20on%20a%20bench%20in%20a%20hospital%20garden%2C%20overcast%20light%2C%20muted%20green%20grey%20palette%2C%20restrained%20emotional%20atmosphere%2C%20no%20text&width=600&height=900&seq=film-poster-21&orientation=portrait",
    tagline: "照顾一个不再认识你的人，还算不算爱？",
    summary:
      "丈夫确诊之后，妻子开始每天写一份照护记录。医生建议她写下「他今天记得什么」，她却越写越多自己的部分。当丈夫的病情进入末期，这本记录变成了她一生中唯一一次完整的告白。",
    analysis: [
      "影片没有把照护拍成感人的牺牲，而是拍成一份工作：翻身、喂药、记录排泄、计算时间。重复的劳动构成了叙事的节拍，也把爱从浪漫拉回现实。",
      "妻子对丈夫的坦白，全部发生在丈夫已经听不懂的时候。这个设定残酷但真实——有些话我们只敢对不会回应的人说。",
      "结尾她在记录本最后一页写下日期，合上本子，去厨房煮了一人份的饭。没有音乐，没有眼泪。导演把悲伤完全交给了日常。",
    ],
    tags: ["照护", "夫妻", "晚年", "疾病"],
    featured: false,
    editorPick: true,
    addedAt: "2025-01-06",
  },
  {
    id: "footsteps-outside",
    title: "门外的脚步声",
    titleEn: "Footsteps Outside",
    year: 2023,
    region: "韩国",
    category: "电视剧",
    genres: ["悬疑伦理", "家庭伦理"],
    director: "尹度贤",
    cast: ["金惠媛", "具承模", "吴承泽"],
    duration: "8集 · 单集52分钟",
    score: 7.8,
    popularity: 81,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20dim%20apartment%20hallway%20with%20a%20peephole%20view%2C%20warm%20lamp%20glow%20behind%20a%20door%2C%20muted%20brown%20and%20slate%20tones%2C%20suspenseful%20mood%2C%20no%20text&width=600&height=900&seq=film-poster-22&orientation=portrait",
    tagline: "每晚十一点，走廊里都会有人走过她家门口。",
    summary:
      "一栋安保良好的新公寓里，独居的插画师开始每晚听见同一个人的脚步声。物业调出监控，走廊整晚空无一人。她决定自己装一台摄像机，却录到了更不愿意面对的东西。",
    analysis: [
      "剧集很懂「声音恐怖」的用法：大部分惊吓来自声场，而不是画面。观众和主角一样，先相信耳朵，再怀疑眼睛。",
      "中段转向家庭伦理，是这部剧最出人意料的地方。脚步声的来源比超自然更让人难受，因为它来自一个本该保护她的人。",
      "结局没有彻底解决恐惧，只让她换了门锁、装了灯。生活在继续，恐惧也继续——这种不圆满，反而更接近真实。",
    ],
    tags: ["公寓", "跟踪", "安全感", "声音恐怖"],
    featured: false,
    editorPick: false,
    addedAt: "2025-06-19",
  },
  {
    id: "autumn-rite",
    title: "秋之祭",
    titleEn: "Autumn Rite",
    year: 2012,
    region: "日本",
    category: "电影",
    genres: ["伦理剧情", "爱情伦理"],
    director: "石川怜",
    cast: ["森川葵", "大西隼人", "高木修"],
    duration: "104分钟",
    score: 7.5,
    popularity: 64,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20Japanese%20autumn%20festival%20at%20night%2C%20paper%20lanterns%20and%20masks%2C%20a%20woman%20turning%20back%20in%20the%20crowd%2C%20muted%20crimson%20and%20deep%20shadow%2C%20no%20text&width=600&height=900&seq=film-poster-23&orientation=portrait",
    tagline: "小镇的祭典每年一次，流言从不散场。",
    summary:
      "在外地工作多年的女人回到小镇参加秋祭，却发现自己的过去已经被讲成了另一个版本。所有人都在善意地提醒她「当年那件事」，而她记得的，完全是另一回事。",
    analysis: [
      "影片最尖锐的地方在于，它让流言成为集体记忆的载体。没有人恶意造谣，每个人都只是「听说」，最后却拼出一个毁掉别人一生的故事。",
      "祭典的灯笼和面具提供了极强的视觉隐喻：在人群里，每个人都戴着别人的脸。女主角只有在摘下面具的瞬间，才被镜头真正对准。",
      "结尾她没有澄清，只是第二年又回来了一次。这个选择很安静，也很倔强——她拒绝再让别人的版本替她说话。",
    ],
    tags: ["祭典", "小镇", "流言", "集体记忆"],
    featured: false,
    editorPick: false,
    addedAt: "2024-06-14",
  },
  {
    id: "double-exposure",
    title: "双重曝光",
    titleEn: "Double Exposure",
    year: 2020,
    region: "韩国",
    category: "电影",
    genres: ["悬疑伦理", "犯罪伦理"],
    director: "车敏书",
    cast: ["韩素理", "赵显宇", "白承勋"],
    duration: "110分钟",
    score: 8.3,
    popularity: 87,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20double%20exposed%20portrait%20of%20a%20woman%20layered%20with%20a%20city%20skyline%2C%20muted%20navy%20and%20warm%20beige%20tones%2C%20analog%20grain%2C%20elegant%20mystery%2C%20no%20text&width=600&height=900&seq=film-poster-24&orientation=portrait",
    tagline: "一张照片里出现了两次她，一次在窗内，一次在窗外。",
    summary:
      "一位纪实摄影师在整理旧胶片时，发现自己二十年前拍下的一张照片里，背景中的人与案件目击者描述高度吻合。她决定重新冲洗那卷底片，却洗出了自己从未拍过的画面。",
    analysis: [
      "影片把「观看」的伦理摆在最前面：摄影师以为自己在记录，其实也在参与。每一次按下快门，都是一次对他人生活的介入。",
      "双重曝光在片中既是技法也是结构。两条时间线在同一格画面里叠印，观众必须自己判断哪一层是真实，哪一层是记忆的残留。",
      "结局没有把主角洗白。她交出了底片，也交出了自己作为旁观者的清白。这是全片最诚实的一笔——记录者从来不是无辜的。",
    ],
    tags: ["摄影", "目击者", "城市", "记录伦理"],
    featured: false,
    editorPick: false,
    addedAt: "2025-03-28",
  },
];